"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiTabOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const useStore_1 = require("../../store/useStore");
const TabSyncService_1 = require("../../services/TabSyncService");
const lucide_react_1 = require("lucide-react");
require("./MultiTabOverlay.css");
const MultiTabOverlay = () => {
    const { currentUser, voiceConnection } = (0, useStore_1.useStore)();
    const [hasWarning, setHasWarning] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (currentUser?.id) {
            TabSyncService_1.tabSyncService.init(currentUser.id, currentUser.displayName || currentUser.username);
        }
        else {
            TabSyncService_1.tabSyncService.cleanup();
        }
        const unsubscribe = TabSyncService_1.tabSyncService.subscribe((warning) => {
            setHasWarning(warning);
        });
        return () => {
            unsubscribe();
        };
    }, [currentUser]);
    // Sync voice status into tabSyncService
    (0, react_1.useEffect)(() => {
        const inVoice = voiceConnection.status === 'connected' || voiceConnection.status === 'connecting';
        TabSyncService_1.tabSyncService.setVoiceActive(inVoice);
    }, [voiceConnection.status]);
    if (!hasWarning) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "multi-tab-voice-banner", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mtvb-left", children: [(0, jsx_runtime_1.jsx)("span", { className: "mtvb-icon-wrap", children: (0, jsx_runtime_1.jsx)(lucide_react_1.AlertTriangle, { size: 15 }) }), (0, jsx_runtime_1.jsx)("span", { className: "mtvb-text", children: "Ayn\u0131 anda iki sekmede bir sesli kanala ba\u011Fl\u0131s\u0131n\u0131z. Sesiniz yank\u0131 yapabilir." })] }), (0, jsx_runtime_1.jsx)("button", { className: "mtvb-close-btn", onClick: () => TabSyncService_1.tabSyncService.dismissWarning(), title: "Uyar\u0131y\u0131 Kapat", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 14 }) })] }));
};
exports.MultiTabOverlay = MultiTabOverlay;
